/**
 * @generated SignedSource<<363449468d2e371a7487fd3c7308bbd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BillingStatus = "billed" | "unbilled" | "%future added value";
export type Currency = "BRL" | "USD" | "%future added value";
export type ReportsPageQuery$variables = {
  billingStatus?: BillingStatus | null | undefined;
  endDate?: string | null | undefined;
  memberIds?: ReadonlyArray<string> | null | undefined;
  projectId?: string | null | undefined;
  startDate?: string | null | undefined;
};
export type ReportsPageQuery$data = {
  readonly projects: ReadonlyArray<{
    readonly color: string | null | undefined;
    readonly id: string;
    readonly name: string;
  }>;
  readonly tasks: ReadonlyArray<{
    readonly billingStatus: BillingStatus;
    readonly currency: Currency;
    readonly date: string;
    readonly description: string | null | undefined;
    readonly durationMinutes: number;
    readonly hourlyRate: number;
    readonly id: string;
    readonly members: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
    readonly project: {
      readonly color: string | null | undefined;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly title: string;
    readonly totalAmount: number;
  }>;
  readonly users: ReadonlyArray<{
    readonly email: string;
    readonly id: string;
    readonly name: string;
  }>;
};
export type ReportsPageQuery = {
  response: ReportsPageQuery$data;
  variables: ReportsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billingStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "color",
    "storageKey": null
  }
],
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "billingStatus",
        "variableName": "billingStatus"
      },
      {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
      },
      {
        "kind": "Variable",
        "name": "memberIds",
        "variableName": "memberIds"
      },
      {
        "kind": "Variable",
        "name": "projectId",
        "variableName": "projectId"
      },
      {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
      }
    ],
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "tasks",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationMinutes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hourlyRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "billingStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Project",
    "kind": "LinkedField",
    "name": "projects",
    "plural": true,
    "selections": (v7/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "users",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportsPageQuery",
    "selections": (v8/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReportsPageQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "3c0098f5a99cc73b6286b6ce84273f0f",
    "id": null,
    "metadata": {},
    "name": "ReportsPageQuery",
    "operationKind": "query",
    "text": "query ReportsPageQuery(\n  $startDate: String\n  $endDate: String\n  $projectId: ID\n  $billingStatus: BillingStatus\n  $memberIds: [ID!]\n) {\n  tasks(startDate: $startDate, endDate: $endDate, projectId: $projectId, billingStatus: $billingStatus, memberIds: $memberIds) {\n    id\n    date\n    title\n    description\n    durationMinutes\n    hourlyRate\n    currency\n    totalAmount\n    billingStatus\n    project {\n      id\n      name\n      color\n    }\n    members {\n      id\n      name\n    }\n  }\n  projects {\n    id\n    name\n    color\n  }\n  users {\n    id\n    name\n    email\n  }\n}\n"
  }
};
})();

(node as any).hash = "8efdc92fb496897bf1b4cb17e36e97f2";

export default node;
